import { Injectable } from '@angular/core';
import { TopCedoleMemoria } from 'src/app/models/topCedoleMemoria';
import { TableObject } from '../../../models/tableObject';
import { Observable } from 'rxjs';
import { ConstantsStore } from '../constants.store';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TopCedoleService {

  constructor(
    private http: HttpClient,
    private urlsStore: ConstantsStore
  ) { }

  public get(
    pageNumber: number,
    pageSize: number,
    filter: string,
    ascending: boolean): Promise<TableObject<TopCedoleMemoria>> {

    return new Promise((resolve, reject) => {
      this.httpGet(pageNumber, pageSize, filter, ascending)
        .toPromise()
        .then(
          (res: TableObject<TopCedoleMemoria>) => resolve(res),
          (error: any) => reject(error)
        );
    });
  }


  httpGet(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const topCedoleMemoriaUrl = `${this.urlsStore.topCedoleMemoriaUrl}/${pageNumber}/${pageSize}${this.urlsStore.filterAndAscendingQueryString(filter, ascending)}`;
    return this.http.get<TableObject<TopCedoleMemoria>>(topCedoleMemoriaUrl);
  }

}
